module.exports = __webpack_public_path__ + "img/b45baa2.svg";